export default "__VITE_ASSET__BfUsBLnZ__"